export class PlatformMessageDto {
    public readonly id: number
    public readonly title?: string
    public readonly message: string
    public readonly domainIds?: number[]
    public readonly startTime?: Date
    public readonly endTime?: Date
    public readonly minVersionReq?: string
    public readonly maintenanceMode?: boolean
}
